import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"

export default function InboxChannelToggle({ value, onChange }) {
  return (
    <Tabs
      value={value}
      onChange={(_, next) => {
        if (next) onChange(next)
      }}
      centered
      variant="standard"
      sx={{
        minHeight: 36,
        "& .MuiTabs-flexContainer": {
          justifyContent: "center",
        },
        "& .MuiTab-root": {
          minHeight: 36,
          minWidth: 104,
          px: 2.5,
          py: 0.5,
        },
      }}
    >
      <Tab label="Email" value="email" />
      <Tab label="SMS" value="sms" />
      <Tab label="Voicemail" value="voicemail" />
    </Tabs>
  )
}
